import styled from 'styled-components';

export const Container = styled.label`
  position: relative;
`;

export const Input = styled.input`
  position: absolute;
  opacity: 0;

  &:checked + span {
    background-color: ${({ theme }) => theme.background_success};
    border: 1px solid ${({ theme }) => theme.background_success};
    opacity: 1;

    &::before {
      left: 20px;
    }
  }
`;

export const SwitchBase = styled.span`
  display: flex;
  cursor: pointer;
  width: 40px;
  height: 24px;
  border-radius: 40px;
  background-color: ${({ theme }) => theme.background_disabled};
  border: 1px solid ${({ theme }) => theme.background_disabled};
  position: relative;
  transition: background-color 0.2s;

  &::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 2px;
    width: 16px;
    height: 16px;
    border-radius: 16px;
    transition: 0.2s;
    background: ${({ theme }) => theme.background_high};
    z-index: 1;
  }
`;
